
import { Spacer } from '@components/1-atoms';
import { IconButton, PageHeader } from '@components/2-molecules';
import { AppTemplate } from '@components/4-templates';
import { ForwardedPageProps } from '@lib/constants';
import React, { FC } from 'react';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';

import Sandwich from '@assets/icons/sandwich';

import {
  WidgetBankChart,
  WidgetManageSubscription,
  WidgetPlaidLink,
  WidgetRecentDocuments,
  WidgetTODOs
} from '@components/3-organisms';



import { useBusiness, useBusinessCountryCurrency } from '@lib/hooks/useBusiness';
import { useChart } from '@lib/hooks/useCharts';
import { useDocuments } from '@lib/hooks/useDocument';
import { useUser } from '@lib/hooks/useUser';

import { useUserSubscriptions, useUserSubscriptionsManageURL } from '@/lib/hooks/useUserSubscription';
import RevenueCatService, { ActiveSubscription } from '@lib/subscription';

const Dashboard: FC<ForwardedPageProps> = ({ navigation, theme, ...props }) => {

  const [user,] = useUser();

  const [business, setBusiness] = useBusiness();
  const [charts, setCharts] = useChart();
  const [currency, setCurrency] = useBusinessCountryCurrency();
  const [documents, setDocuments] = useDocuments();

  const [activeSubscriptions, setActiveSubscriptions] = React.useState<ActiveSubscription[]>([]);

  const [userSubscription,] = useUserSubscriptions();
  const [userSubscriptionManagementURL,] = useUserSubscriptionsManageURL();


  React.useEffect(() => {
    const _ = async () => {
      const activeSubscriptions = await RevenueCatService.getActiveSubscriptions();
      setActiveSubscriptions(activeSubscriptions);
    }
    _();
  }, []);

  return (
    <AppTemplate hooks={[user, business, charts, currency, documents]} panToOpenDrawer>

      <PageHeader
        dontGoBack
        title={"DASHBOARD"}
        left={<IconButton transparent icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
      // menu={<DashboardMenu navigation={navigation} />}
      />
      <Spacer h={1} />

      <WidgetTODOs navigation={navigation} />
      <Spacer h={1} />

      {
        // Conditionally display chart insights from the bank or Plaid link to link bank
        // The chart is display if chart data is NOT empty
        (charts?.data?.length) ?
          <WidgetBankChart
            data={charts?.data}
            currency={currency?.data?.symbol}
            navigation={navigation}
          />
          :
          <WidgetPlaidLink navigation={navigation} />
      }
      <Spacer h={1} />

      {/* <WidgetSummaryOfEstimates
        data={documents?.data}
        currency={currency?.data?.symbol}
        navigation={navigation}
      />
      <Spacer h={1} /> */}

      <WidgetRecentDocuments
        data={documents?.data}
        currency={currency?.data?.symbol}
        navigation={navigation}
      />
      <Spacer h={1} />

      {/* // Widget to manage subscription(s) */}
      <WidgetManageSubscription
        data={userSubscription?.data}
        managementURL={userSubscriptionManagementURL?.data}
      />
      <Spacer h={1} />

      <Spacer h={2} />
    </AppTemplate>
  );
};


export default withForwardedNavigationParams<ForwardedPageProps>()(Dashboard);